export const darkTheme = {
  bg: "#090917",
  bgLight: "#1C1E27",
  primary: "#854CE6",
  text_primary: "#F2F3F4",
  text_secondary: "#b1b2b3",
  card: "#171721",
  card_light: "#191924",
  button: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
  bg: "#EDF2F7",          // Soft Blue-Gray background
  bgLight: "#F7FAFC",     // Lighter section background
  primary: "#854CE6",
  text_primary: "#111827",
  text_secondary: "#4B5563",
  card: "#FFFFFF",        // Pure white cards for pop
  card_light: "#F3F4F6",
  button: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
};